import { render, staticRenderFns } from "./RegisterAdmin.vue?vue&type=template&id=45099918&scoped=true"
import script from "./RegisterAdmin.vue?vue&type=script&lang=js"
export * from "./RegisterAdmin.vue?vue&type=script&lang=js"
import style0 from "./RegisterAdmin.vue?vue&type=style&index=0&id=45099918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45099918",
  null
  
)

export default component.exports